import React, { useEffect, useMemo, useRef, useState } from 'react'
import moment from 'moment'
import { hapticTick } from '../../../../_utils/haptics'
import { marketingApiService } from '../../services/marketingApiService'
import { useSalonBrand } from '../brand/useSalonBrand'
import { marketFor, normHex } from '../email-composer/email/theme'
import { salonLinks } from '../email-composer/email/links'
import { familyForLook } from '../social/render/families'
import { loadPosts, subscribePosts } from '../social/data/store'
import { townOf } from '../social/data/captions'
import BaileyMark from '../social/components/BaileyMark'
import PostStudio from '../social/components/PostStudio'
import MarketingCalendar from '../calendar/components/MarketingCalendar'
import { loadCampaigns, loadSitePosts } from '../calendar/data/calendarData'
import { useMarketingSites } from '../calendar/data/siteScope'
import { usePlans } from '../plans/usePlans'
import { dismissPlan, undismissPlan } from '../plans/data/planStore'
import { planSuggestions } from '../plans/data/planner'
import { campaignBands } from '../calendar/data/calendarData'
import PlanCard from '../plans/components/PlanCard'
import { planPath, campaignPath } from '../campaigns/data/open'
import { listCampaigns } from '../campaigns/data/campaignStore'
import { loadSends, loadOverview, loadVouchers, loadFrontDesk, loadJourneys } from '../performance/data/load'
import { bookingsBySource, funnel, inRange, lastFourWeeks, voucherResults } from '../performance/data/results'
import { AGENT_VISIBLE, DISCOUNTS_VISIBLE } from '../../../../config/featureFlags'
import { useLiveCodes } from '../../../discounts/discountStore'
import { marketingAction } from '../../../../_actions/marketing.actions'
import SmsWalletTopupModal from '../sms-composer/SmsWalletTopupModal'
import { formatPence, walletBalancePence, messagePrices } from '../../../pricing/money'
import '../../../marketing/campaigns/Campaigns.css'
import { hydrateLoyalty, currentOwnerId } from '../../../loyalty-v2/loyaltyStore'
import { UndoIcon } from '../social/components/icons'
import useWindowSize from '../../../new-service/useWindowSize'
import { useHeldHeight, layoutAt } from './useHeldHeight'
import '../../../settings/SettingsHub.css'
import '../../../catalogue/CatalogueOverview.css'
import '../social/Social.css'
import './Home.css'

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`
const greeting = (d = new Date()) => (d.getHours() < 12 ? 'Good morning' : d.getHours() < 18 ? 'Good afternoon' : 'Good evening')

const Chevron = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
const I = ({ d }) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{d}</svg>
const ICONS = {
  calendar: <I d={<><rect x="3" y="4" width="18" height="17" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></>} />,
  campaigns: <I d={<><path d="m3 11 15-6v14l-15-6v-2Z" /><path d="M11.6 16.8a3 3 0 1 1-5.2-3" /><path d="M18 8a4 4 0 0 1 0 8" /></>} />,
  social: <I d={<><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" /></>} />,
  journeys: <I d={<><circle cx="5" cy="6" r="2.4" /><circle cx="19" cy="18" r="2.4" /><path d="M7.4 6H15a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H9a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3h7.6" /></>} />,
  loyalty: <I d={<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z" />} />,
  discounts: <I d={<><path d="M3 8a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 0-2 2H5a2 2 0 0 0-2-2v-2a2 2 0 0 0 0-4z" /><path d="M9.5 14.5l5-5" /></>} />,
  communications: <I d={<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />} />,
  performance: <I d={<><path d="M3 3v16a2 2 0 0 0 2 2h16" /><path d="M7 14l4-4 3 3 5-6" /></>} />,
  config: <I d={<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68 1.65 1.65 0 0 0 10 3.17V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></>} />,
}

const Row = ({ r, onGo }) => (
  <button type="button" className="settings-hub-row" onClick={() => onGo(r.path)}>
    <span className="settings-hub-row-icon">{ICONS[r.id]}</span>
    <span className="settings-hub-row-text">
      <b>{r.label}</b>
      <span>{r.desc}</span>
      {r.pills.filter(Boolean).length > 0 && <span className="co-pills">{r.pills.filter(Boolean).map((p) => <span key={p.t} className={`co-pill is-${p.tone}`}>{p.t}</span>)}</span>}
    </span>
    <span className="settings-hub-row-chevron"><Chevron /></span>
  </button>
)

// Marketing › Home: what Bailey has ready, what's going out, what it's
// bringing in, and every part of marketing a tap away. Same bones as the
// Catalogue and Settings homes.

// The channels Bailey's plans really use ("posts and Stories" for someone
// with nobody to email or text yet), as the header says them
const plansReach = (plans) => {
  const ch = new Set(plans.flatMap(p => (p.items || []).map(i => i.channel)))
  const parts = [ch.has('sms') && 'texts', ch.has('email') && 'emails', ch.has('post') && 'posts', ch.has('story') && 'Stories'].filter(Boolean)
  if (!parts.length) return 'posts and Stories'
  return parts.length === 1 ? parts[0] : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`
}

const MarketingHomePage = ({ dispatch, user, history, managed }) => {
  const brand = useSalonBrand()
  const salon = brand.salon
  const hairdresser = (user && user.userInfo && user.userInfo.hairdresser) || {}
  const userSalon = hairdresser.salon
  const trade = marketFor(salon && salon.businessType) || marketFor(userSalon && userSalon.businessType) || 'hair'
  const salonName = brand.spec.name || (salon && salon.salonName) || (userSalon && userSalon.salonName) || ''
  const brandColour = normHex(brand.spec.accent) || null
  const family = familyForLook(brand.spec.look)
  const town = townOf(salon && salon.formattedAddress)
  const info = (user && user.userInfo) || {}
  const firstName = String(info.first_name || info.name || '').trim().split(/\s+/)[0]
  const currency = hairdresser.currencySymbol || '£'
  const kit = useMemo(() => ({ name: salonName || 'Your salon', accent: brandColour, logo: brand.spec.logo || null, display: brand.spec.display || null, text: brand.spec.text || null }), [salonName, brandColour, brand.spec.logo, brand.spec.display, brand.spec.text])
  const ctx = useMemo(() => ({ market: trade, kit: brand.spec, links: salonLinks(hairdresser), salonName }), [trade, brand.spec, salonName]) // eslint-disable-line react-hooks/exhaustive-deps

  const country = String((userSalon && (userSalon.countryShortName || userSalon.country)) || 'GB').toUpperCase().slice(0, 2)
  const { loading, plans, templates, campaigns, planForDay } = usePlans({ dispatch, user, trade, salonName, brandColour, family, country, links: ctx.links, currency, enabled: !managed })
  // Bailey's plans and the week's calendar fill in after the page draws:
  // until they do, each holds the height it had last time, so nothing below
  // moves under someone already reading
  const { width } = useWindowSize()
  const layout = layoutAt(width || (typeof window !== 'undefined' ? window.innerWidth : 1280))
  const [baileyRef, baileyHold] = useHeldHeight('bailey', layout, !loading)
  const [calReady, setCalReady] = useState(false)
  const [calRef, calHold] = useHeldHeight('calendar', layout, calReady && (managed || !loading))
  // Seasons coming up that Bailey isn't suggesting yet: so nothing arrives as a surprise
  const comingUp = useMemo(() => {
    const shown = new Set(plans.map(p => p.key))
    const made = new Set((campaigns || []).map(c => c.planKey).filter(Boolean))
    return templates.filter(t => !shown.has(t.key) && !made.has(t.key) && moment(t.start).isBefore(moment().add(75, 'days'))).slice(0, 3)
  }, [plans, templates, campaigns])
  // Plans open in the Campaign Studio, which brings them back here on close
  const review = (plan) => { if (plan) { hapticTick(); history.push(planPath(plan), { from: '/marketing-home' }) } }
  const [studio, setStudio] = useState(null)
  // The message balance, the same as on Campaigns (pounds, never credits)
  const [wallet, setWallet] = useState(null)
  const [topup, setTopup] = useState(false)
  const loadWallet = () => dispatch(marketingAction.getSettings()).then((res) => {
    const r = res && res.data && res.data.responseData && res.data.responseData.result
    const pence = walletBalancePence(r)
    if (r && pence != null) setWallet({ pence, canTopUp: r.canTopUpWallet !== false, costs: r.creditCosts || null, prices: messagePrices(r), autoRecharge: r.autoRecharge || null })
  }).catch(() => {})
  useEffect(() => { if (!managed) loadWallet() }, [managed]) // eslint-disable-line react-hooks/exhaustive-deps
  const [toast, setToast] = useState(null)
  const [posts, setPosts] = useState(loadPosts)
  // Discount codes live now (Marketing › Discounts)
  const liveCodeState = useLiveCodes()
  const [facts, setFacts] = useState({ campaigns: null, overview: undefined, journeys: undefined, loyalty: undefined, counts: null, sends: undefined, vouchers: undefined, frontDesk: undefined })
  // Locations filter: what's going out (campaigns and planned posts) and the
  // calendar can span locations. The four-week numbers are Performance's for
  // this location, and say so when more than one is picked.
  const locations = useMarketingSites()
  const [sitePosts, setSitePosts] = useState([])
  // The same four weeks Performance opens on, so the two never disagree
  const range = useMemo(() => lastFourWeeks(), [])

  useEffect(() => subscribePosts(() => setPosts(loadPosts())), [])
  useEffect(() => {
    let alive = true
    const put = (k) => (v) => { if (alive) setFacts(f => ({ ...f, [k]: v })) }
    loadOverview(dispatch, range).then(put('overview'), () => put('overview')(null))
    loadSends(dispatch).then(put('sends'), () => put('sends')([]))
    loadVouchers(range).then(put('vouchers'), () => put('vouchers')(null))
    // Each journey with the clients who have been through it
    loadJourneys().then(put('journeys'), () => put('journeys')(null))
    if (AGENT_VISIBLE) loadFrontDesk(range.start).then(put('frontDesk'), () => put('frontDesk')(null)); else put('frontDesk')(null)
    hydrateLoyalty(currentOwnerId()).then(r => put('loyalty')(r && r.scheme)).catch(() => put('loyalty')(null))
    Promise.all(['email', 'sms'].map(type => marketingApiService.getCampaignsPaged(dispatch, { type, currentPage: 1, limit: 1 }).then(r => r.statusCounts || {}).catch(() => ({}))))
      .then(([email, sms]) => put('counts')({ email, sms }))
    return () => { alive = false }
  }, [dispatch, range])
  useEffect(() => {
    let alive = true
    setFacts(f => ({ ...f, campaigns: null }))
    loadCampaigns(dispatch, { salonIds: locations.param })
      .then(l => { if (alive) setFacts(f => ({ ...f, campaigns: l })) })
      .catch(() => { if (alive) setFacts(f => ({ ...f, campaigns: [] })) })
    if (locations.param) {
      loadSitePosts({ from: new Date(), to: moment().add(7, 'days').toDate(), salonIds: locations.param })
        .then(l => { if (alive) setSitePosts(l) }).catch(() => { if (alive) setSitePosts([]) })
    } else setSitePosts([])
    return () => { alive = false }
  }, [dispatch, locations.param])

  const toastTimer = useRef(null)
  useEffect(() => () => clearTimeout(toastTimer.current), [])
  const say = (text, undo) => {
    clearTimeout(toastTimer.current)
    setToast({ text, undo, at: Date.now() })
    toastTimer.current = setTimeout(() => setToast(null), 5000)
  }

  // ─── The numbers ───
  // Worked out exactly as Performance's Overview does (performance/data)
  const sentIn = (facts.sends || []).filter(s => inRange(s.at, range))
  const all = funnel(sentIn)
  const emails = funnel(sentIn.filter(s => s.kind === 'email'))
  const reached = all.delivered
  const fd = facts.frontDesk && facts.frontDesk.used ? facts.frontDesk.conversations : null
  const bookings = facts.sends ? bookingsBySource({ sends: facts.sends, groups: listCampaigns(), frontDesk: fd, journeys: facts.journeys || null }, range).total : 0
  const fromBookings = facts.overview ? (facts.overview.attributedRevenue ?? facts.overview.revenue ?? null) : null
  const vouchers = voucherResults(facts.vouchers)
  const revenue = fromBookings == null && !vouchers ? null : (Number(fromBookings) || 0) + ((vouchers && vouchers.revenue) || 0)
  const numbersIn = facts.sends !== undefined && facts.overview !== undefined && facts.vouchers !== undefined && facts.frontDesk !== undefined && facts.journeys !== undefined
  const week = moment().add(7, 'days').endOf('day')
  const upcoming = (facts.campaigns || []).filter(c => c.status === 'scheduled' && moment(c.at).isAfter(moment()) && moment(c.at).isBefore(week))
  const plannedIn = (list) => list.filter(p => p.status === 'planned' && p.plannedAt && moment(p.plannedAt).isBefore(week) && moment(p.plannedAt).isAfter(moment().startOf('day')))
  const plannedPosts = plannedIn(posts)
  const plannedEverywhere = locations.spans ? plannedPosts.concat(plannedIn(sitePosts)) : plannedPosts
  const where = locations.spans ? ` · ${locations.count} locations` : ''
  const hereOnly = locations.spans ? ' · this location' : ''
  const money = (n) => `${currency}${Math.round(Number(n) || 0).toLocaleString('en-GB')}`

  const tiles = [
    {
      key: 'revenue', label: 'Brought in', dim: `4 weeks${hereOnly}`, path: '/marketing-performance',
      value: !numbersIn ? null : revenue != null && revenue > 0 ? money(revenue) : bookings ? plural(bookings, 'booking', 'bookings') : 'Nothing yet',
      stats: revenue != null && revenue > 0 ? [[String(bookings), bookings === 1 ? 'booking' : 'bookings']] : [],
      empty: 'Bookings and gift vouchers that come from your marketing add up here.',
    },
    {
      key: 'reach', label: 'Reached', dim: `4 weeks${hereOnly}`, path: '/marketing-performance?tab=campaigns',
      value: facts.sends === undefined ? null : reached ? plural(reached, 'client', 'clients') : 'Nobody yet',
      stats: reached ? [...(emails.clickRate != null ? [[`${Math.round(emails.clickRate)}%`, 'tapped your emails']] : []), [String(all.count), all.count === 1 ? 'email or text' : 'emails and texts']] : [],
      empty: 'Send an email or a text and who it reached shows here.',
    },
    {
      key: 'next', label: 'Going out', dim: `Next 7 days${where}`, path: '/marketing-calendar',
      value: facts.campaigns === null ? null : (upcoming.length + plannedEverywhere.length) ? plural(upcoming.length + plannedEverywhere.length, 'thing', 'things') : 'Nothing planned',
      stats: (upcoming.length + plannedEverywhere.length) ? [
        [String(upcoming.filter(c => c.kind === 'email').length), upcoming.filter(c => c.kind === 'email').length === 1 ? 'email' : 'emails'],
        [String(upcoming.filter(c => c.kind === 'sms').length), upcoming.filter(c => c.kind === 'sms').length === 1 ? 'text' : 'texts'],
        [String(plannedEverywhere.length), plannedEverywhere.length === 1 ? 'post' : 'posts'],
      ] : [],
      empty: plans.length ? 'Approve one of Bailey’s plans and it lands here.' : 'Plan something and it lands here.',
    },
  ]

  // ─── Every part of marketing ───
  const c = facts.counts || {}
  const scheduled = ((c.email && c.email.scheduled) || 0) + ((c.sms && c.sms.scheduled) || 0)
  const drafts = ((c.email && c.email.draft) || 0) + ((c.sms && c.sms.draft) || 0)
  const liveJourneys = ((facts.journeys && facts.journeys.list) || []).filter(j => j.status === 'ready').length
  const scheme = facts.loyalty
  const draftPosts = posts.filter(p => p.status === 'draft').length
  const liveCodes = liveCodeState.codes.length
  const groups = [
    {
      title: 'Reach your clients', sub: 'Things you send and post',
      rows: [
        { id: 'campaigns', label: 'Campaigns', path: '/marketing-campaigns', desc: facts.counts ? (scheduled || drafts ? [scheduled && `${scheduled} scheduled`, drafts && plural(drafts, 'draft', 'drafts')].filter(Boolean).join(', ') : 'Emails and texts to your clients') : 'Loading…', pills: [] },
        { id: 'social', label: 'Social', path: '/marketing-social', desc: plannedPosts.length ? `${plural(plannedPosts.length, 'post', 'posts')} planned this week` : 'Instagram and TikTok posts, made for you', pills: [draftPosts && { tone: 'ok', t: plural(draftPosts, 'draft', 'drafts') }] },
        { id: 'calendar', label: 'Calendar', path: '/marketing-calendar', desc: 'Posts, emails and texts, by day', pills: [] },
      ],
    },
    {
      title: 'Runs by itself', sub: 'Set up once, works every day',
      rows: [
        { id: 'journeys', label: 'Journeys', path: '/marketing-journeys', desc: facts.journeys === undefined ? 'Loading…' : liveJourneys ? `${plural(liveJourneys, 'journey', 'journeys')} running` : 'Welcome, win-back and birthday messages', pills: [] },
        ...(DISCOUNTS_VISIBLE ? [{ id: 'discounts', label: 'Discount codes', path: '/marketing-discounts', desc: !liveCodeState.loaded ? 'Loading…' : liveCodes ? `${plural(liveCodes, 'code', 'codes')} live` : 'Codes for posts, emails and bookings', pills: [] }] : []),
        { id: 'loyalty', label: 'Loyalty', path: '/marketing-loyalty', desc: scheme === undefined ? 'Loading…' : scheme ? (scheme.status === 'live' ? 'Your scheme is live' : 'Your scheme is paused') : 'Stamp cards and points', pills: [scheme && scheme.status !== 'live' && { tone: 'warn', t: 'Paused' }] },
        { id: 'communications', label: 'Communications', path: '/marketing', desc: 'Reminders, booking updates and review requests', pills: [] },
      ],
    },
    {
      title: 'Results and settings', sub: 'How it’s going, and how it’s set up',
      rows: [
        { id: 'performance', label: 'Performance', path: '/marketing-performance', desc: revenue ? `${money(revenue)} brought in` : 'Bookings and money from your marketing', pills: [] },
        { id: 'config', label: 'Config', path: '/marketing-setting', desc: 'Your brand, business details and message balance', pills: [] },
      ],
    },
  ]

  // Every section opens below the home, so its Back comes back here (goUp)
  const HOME = '/marketing-home'
  const go = (path) => { hapticTick(); history.push(path, { from: HOME }) }
  const dismiss = (plan, reason) => {
    dismissPlan(plan.key, reason)
    say(reason === 'not-for-us' ? 'Got it. Bailey won’t suggest that kind of plan for a while.' : 'Put away for now.', () => undismissPlan(plan.key))
  }

  return (
    <div className="settings-hub co-page mh-page">
      {/* Tall enough for the credits from the start, so they arrive without pushing the page down */}
      <div className={`co-head${managed ? '' : ' mh-head-credits'}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <h1 className="settings-hub-title mh-title">Marketing</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginLeft: 'auto' }}>
        {!managed && wallet && (
          <div className={`cmp-allowance${wallet.canTopUp ? ' cmp-allowance--buy' : ''}`}>
            <div className="cmp-allowance-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13 2 3 14h7l-1 8 11-14h-7l1-6z" /></svg></div>
            <div>
              <div className="cmp-allowance-num">{formatPence(wallet.pence)}</div>
              <div className="cmp-allowance-label">Balance</div>
            </div>
            {wallet.canTopUp && <button type="button" className="cmp-allowance-buy" onClick={() => { hapticTick(); setTopup(true) }}>Top up</button>}
          </div>
        )}
        </div>
      </div>

      {!managed && (
        <section className={`mh-bailey${loading ? ' is-loading' : ''}`} aria-label="Bailey’s plans" aria-busy={loading} ref={baileyRef} style={baileyHold ? { minHeight: baileyHold } : undefined}>
          <div className="mh-bailey-head">
            <BaileyMark size={52} thinking={loading} />
            <div className="mh-bailey-text">
              <h2>{greeting()}{firstName ? `, ${firstName}` : ''}.</h2>
              <p>
                {loading ? 'Bailey is looking at your diary, reviews and dates coming up…'
                  : plans.length ? `Bailey has ${plans.length === 1 ? 'a plan' : `${plans.length} plans`} ready. Approve ${plans.length === 1 ? 'it' : 'one'} and it goes out on its own, ${plansReach(plans)}.`
                    : 'You’re all set for now. Bailey keeps an eye on your diary and reviews, and has something ready when it’s worth it.'}
              </p>
            </div>
          </div>
          {loading && <div className="mh-plans">{[0, 1, 2].map(i => <div key={i} className="mh-plan-hold" aria-hidden />)}</div>}
          {!loading && plans.length > 0 && (
            <div className="mh-plans">
              {plans.map(p => <PlanCard key={p.key} plan={p} kit={kit} salonName={salonName} onReview={review} onDismiss={dismiss} onAction={(x) => history.push(x.action.path, { ...(x.action.state || {}), from: '/marketing-home' })} />)}
            </div>
          )}
          {!loading && comingUp.length > 0 && (
            <div className="mh-coming">
              <span className="mh-coming-label">Coming up</span>
              <div className="mh-coming-row">
                {comingUp.map(t => (
                  <button key={t.key} type="button" className="mh-coming-card" onClick={() => review(t)}>
                    <span className="mh-coming-when">From {moment(t.start).format('ddd D MMM')}</span>
                    <b>{t.title}</b>
                    <small>{moment(t.end).diff(moment(t.start), 'days') + 1} days · {plural(t.items.filter(i => i.on).length, 'thing', 'things')}</small>
                    <span className="mh-coming-go">Take a look</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </section>
      )}

      <div className="co-tiles mh-tiles">
        {tiles.map(t => (
          <button type="button" className="co-tile" key={t.key} onClick={() => go(t.path)}>
            <span className="co-tile-label"><span>{t.label}</span><span className="co-tile-label-dim">{t.dim}</span></span>
            {t.value === null ? (
              <>
                <span className="co-tile-skel" />
                <span className="co-tile-skel co-tile-skel--short" />
              </>
            ) : (
              <>
                <span className={`co-tile-value mh-tile-value${t.stats.length ? '' : ' co-tile-value--empty'}`}>{t.value}</span>
                {t.stats.length ? (
                  <span className="co-tile-stats">{t.stats.map(([v, l]) => <span className="co-tile-stat" key={l}><b>{v}</b><small>{l}</small></span>)}</span>
                ) : <span className="co-tile-empty">{t.empty}</span>}
              </>
            )}
          </button>
        ))}
      </div>

      <div className="mh-calendar" ref={calRef} style={calHold ? { minHeight: calHold } : undefined}>
        <MarketingCalendar
          onReady={() => setCalReady(true)}
          showLocations={false}
          dispatch={dispatch}
          trade={trade}
          kit={kit}
          title="This week"
          plans={managed ? [] : planSuggestions(plans)}
          bands={campaignBands({ campaigns, plans: managed ? [] : plans })}
          onOpenBand={(b) => {
            if (b.planKey) review(plans.find(p => p.key === b.planKey) || null)
            else history.push(campaignPath(b.campaignId), { from: '/marketing-home' })
          }}
          onOpenPlan={(it) => review(plans.find(p => p.key === it.planKey) || null)}
          createKinds={managed ? ['post'] : ['post', 'email', 'sms', 'bailey']}
          onOpenFull={() => go('/marketing-calendar')}
          onOpenPost={(p) => setStudio(p)}
          onOpenCampaign={(item) => history.push('/marketing-campaigns', { openCampaignId: item.id, from: '/marketing-home' })}
          onCreate={(day, kind) => {
            if (kind === 'bailey') review(planForDay(day))
            else if (kind === 'post') history.push('/marketing-social', { create: true, day: day.toISOString(), from: '/marketing-home' })
            else history.push('/marketing-campaigns', { compose: kind, from: '/marketing-home' })
          }}
        />
      </div>

      <div className="settings-hub-groups mh-groups">
        {groups.map(g => (
          <section className="settings-hub-group" key={g.title}>
            <div className="settings-hub-group-head"><h2>{g.title}</h2><small>{g.sub}</small></div>
            {g.rows.map(r => <Row key={r.id} r={r} onGo={go} />)}
          </section>
        ))}
      </div>

      {/* pencePerCredit is ignored by the modal now; it stays because
          eslint-plugin-react-hooks 1.7 miscounts this component's code paths
          without that branch and reports every hook as conditional. */}
      {topup && wallet && (
        <SmsWalletTopupModal balancePence={wallet.pence} prices={wallet.prices} creditCosts={wallet.costs} pencePerCredit={wallet.costs && wallet.costs.pencePerCredit} autoRecharge={wallet.autoRecharge} onSuccess={() => loadWallet()} onClose={() => setTopup(false)} />
      )}
      {studio && (
        <PostStudio post={studio} kit={kit} trade={trade} salonName={salonName} town={town} salon={salon} onClose={() => setStudio(null)} />
      )}
      {toast && (
        <div className="sx-toast" role="status" key={toast.at}>
          <span>{toast.text}</span>
          {toast.undo && <button type="button" onClick={() => { toast.undo(); setToast(null) }}><UndoIcon size={14} />Undo</button>}
        </div>
      )}
    </div>
  )
}

export default MarketingHomePage
